import Header from "../../components/StudentPortal/Header/Header";
import CourseComponent from "../../components/StudentPortal/Course/Course";
import { useEffect } from "react";
export default function Course() {
  useEffect(() => {
    document.title = "Course - LWS Learning Portal";
  }, []);

  return (
    <>
      <Header />
      <section className="py-6 bg-primary">
        <div className="mx-auto max-w-7xl px-5 lg:px-0">
          <CourseComponent />
        </div>
      </section>
    </>
  );
}
